export default "__VITE_ASSET__Bx_5cLcF__"